import SearchAroundModal from '@ui/Search/Around/Modal/component'

export default function (): void {
  const searchAround = SearchAroundModal('search-around', {
    onSubmit: ({ city, maxDistance }) => {
      const autocompleteFieldEl = document.getElementById('search_offers_autocomplete_autocomplete') as HTMLInputElement

      autocompleteFieldEl.value = city

      const maxDistanceEl = document.getElementById('search_offers_maxDistance') as HTMLInputElement | null

      if (maxDistanceEl && maxDistance) {
        maxDistanceEl.value = maxDistance
      }

      document.getElementById('search_offers_search')?.click()
    },
  })

  if (!searchAround) {
    return
  }

  document.querySelectorAll('.search__around-link').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      searchAround.open()
    })
  })
}
